function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0.7 8.75C1.0866 8.75 1.4 9.04381 1.4 9.40625V12.0312C1.4 12.2053 1.47375 12.3722 1.60503 12.4953C1.7363 12.6184 1.91435 12.6875 2.1 12.6875H11.9C12.0857 12.6875 12.2637 12.6184 12.395 12.4953C12.5263 12.3722 12.6 12.2053 12.6 12.0312V9.40625C12.6 9.04381 12.9134 8.75 13.3 8.75C13.6866 8.75 14 9.04381 14 9.40625V12.0312C14 12.5534 13.7788 13.0542 13.3849 13.4234C12.9911 13.7926 12.457 14 11.9 14H2.1C1.54305 14 1.0089 13.7926 0.615076 13.4234C0.221249 13.0542 0 12.5534 0 12.0312V9.40625C0 9.04381 0.313401 8.75 0.7 8.75Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.83857 5.43306C3.12333 5.18898 3.58501 5.18898 3.86977 5.43306L7 8.11612L10.1302 5.43306C10.415 5.18898 10.8767 5.18898 11.1614 5.43306C11.4462 5.67714 11.4462 6.07286 11.1614 6.31694L7.5156 9.44194C7.23084 9.68602 6.76916 9.68602 6.4844 9.44194L2.83857 6.31694C2.55381 6.07286 2.55381 5.67714 2.83857 5.43306Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7 0C7.48325 0 7.875 0.307804 7.875 0.6875V8.9375C7.875 9.3172 7.48325 9.625 7 9.625C6.51675 9.625 6.125 9.3172 6.125 8.9375V0.6875C6.125 0.307804 6.51675 0 7 0Z"
});

var SvgDownload = function SvgDownload(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "#6D7F92",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDownload, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/download.980f03bc.svg";
export { ForwardRef as ReactComponent };